// src/components/Register/styles.ts
import styled from 'styled-components';
import { Box, TextField } from '@mui/material';

export const SBox = styled(Box)`
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 360px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
   
    @media (max-width: 768px) {
        max-width: 350px;
    }
`;

export const SForm = styled.form`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    
    @media (max-width: 768px) {
        max-width: 350px;
    }

    & > * {
        margin-bottom: 16px;
    }
`;

export const SCustomHelperText = styled.span<{ error: boolean }>`
    color: ${({ error }) => (error ? '#d32f2f' : '#757575')};
    font-size: 14px;
    margin-top: 4px;
    font-family: 'IRANYekanXFaNum';
    /* direction (not just text-align) so Persian punctuation sits on the left end */
    direction: rtl;
    text-align: right;
    display: block;
`;

export const STextFieldWrapper = styled.div`
    width: 100%;
    min-height: 48px;
    position: relative;
    margin-bottom: 8px;
`;

export const STextFieldBackground = styled.div`
    width: 100%;
    height: 48px;
    position: absolute;
    border-radius: 8px;
    border: 1px solid #D9D9DD;
    background-color: #FFFFFF;
`;

export const STextField = styled(TextField)`
    width: 100%;
    border-radius: 8px;
    margin: 0;

    /* The 48px belongs to the input box, not the whole field: the TextField
       also contains the helper text, so fixing its height clips the error. */
    .MuiOutlinedInput-root {
        height: 48px;
        input {
            color: #35373C;
            font-family: 'IRANYekanXFaNum';
            font-size: 14px;
            font-weight: 600;
            text-align: center;
            letter-spacing: 8px;
            height: 48px;
            padding: 0;
        }

        fieldset {
            border: none;
        }

        input::placeholder {
            color: #BBC0CB;
            font-family: 'IRANYekanXFaNum';
            font-size: 14px;
            font-weight: 600;
            text-align: center;
            letter-spacing: 8px;
        }
    }

    .MuiFormHelperText-root {
        /* direction (not just text-align) so Persian punctuation sits on the left end */
        direction: rtl;
        text-align: right;
        margin: 4px 0 0 0;
    }
`;

export const SLabel = styled.label`
    color: #60646E;
    font-size: 14px;
    font-family: 'IRANYekanXFaNum';
    font-weight: 500;
    text-align: right;
    margin: 2px 0 2px 2px;
    word-wrap: break-word;
    display: block;
`;

export const SLableInputCode = styled(SLabel)`
    margin: 2px 0 24px 1px;
    font-size: 12px;
    font-weight: 600;
    color: #60646E;
`;

export const SLinkContainer = styled(Box)`
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 1px;
`;

/** Inert label, styled to match SClickableText but without the affordances. */
export const SStaticText = styled.span`
    color: #60646E;
    font-size: 12px;
    font-family: 'IRANYekanXFaNum';
    font-weight: 500;
`;

export const SClickableText = styled.span`
    cursor: pointer;
    color: #60646E;
    font-size: 12px;
    font-family: 'IRANYekanXFaNum';
    font-weight: 500;
    transition: color 0.2s ease;

    &:hover {
        text-decoration: underline;
        color: #35373C;
    }
`;

export const SResendText = styled.span`
    cursor: pointer;
    color: #0066CC;
    font-size: 12px;
    font-family: 'IRANYekanXFaNum';
    font-weight: 700;
    padding: 8px 16px;
    border-radius: 4px;
    display: inline-block;
    transition: all 0.3s ease;
    background-color: rgba(0, 102, 204, 0.1);

    &:hover {
        background-color: rgba(0, 102, 204, 0.2);
        text-decoration: none;
    }

    &:active {
        transform: scale(0.98);
    }
`;

export const SClickableTextDetails = styled(SLabel)`
    margin: 2px 0 12px 12px;
    margin-bottom: 0px;
    font-family: 'IRANYekanXFaNum';
    font-size: 12px;
    color: #35373C;
`;

export const SClickableTextBlue = styled(SClickableText)`
    color: #0066CC;

    &:hover {
        color: #004D99;
    }
`;

export const SClickableTextRegister = styled(SClickableText)`
    color: #0066CC;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 8px;

    &:hover {
        color: #004D99;
    }
`;

export const SDivider = styled.hr`
    width: 100%;
    border: none;
    border-top: 1px dotted #D9D9DD;
    margin: 20px 0;
`;

export const STitle = styled.div`
    margin: 2px 0 12px 12px;
    color: #25282E;
    font-size: 20px;
    font-family: 'IRANYekanXFaNum';
    font-weight: 900;
    line-height: 1.4;
`;

// Circular Timer Styles
export const SCircularTimerContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  direction: ltr;
`;

export const SCircularProgressContainer = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SCircularProgressText = styled.span`
  font-family: 'IRANYekanXFaNum';
  font-size: 12px;
  font-weight: 700;
  color: #0066CC;
  
  &.warning {
    color: #FF3D00;
  }
`;

export const SResendLabel = styled.span`
  font-family: 'IRANYekanXFaNum';
  font-size: 12px;
  font-weight: 500;
  color: #60646E;
  margin-left: 8px;
`;

export const STimerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 8px;
`;

// Alert Styles
export const SAlert = styled.div`
  width: 100%;
  padding: 8px 16px;
  border-radius: 4px;
  font-family: 'IRANYekanXFaNum';
  font-size: 14px;
  text-align: right;
  margin-bottom: 16px;
  
  &.error {
    background-color: #F8D7DA;
    color: #D32F2F;
    border: 1px solid #F5C6CB;
  }
  
  &.success {
    background-color: #D4EDDA;
    color: #155724;
    border: 1px solid #C3E6CB;
  }
`;
